var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    loadingIdentifiers: {},
    isLoaderEnabled: false,
};
export var loadingSlice = createSlice({
    name: 'loadingStore',
    initialState: initialState,
    reducers: {
        addInstance: function (state, action) {
            var _a;
            var _b, _c;
            var loadingIdentifiers = state.loadingIdentifiers;
            var identifier = action.payload.identifier;
            var instanceCount = (_c = (_b = loadingIdentifiers[identifier]) === null || _b === void 0 ? void 0 : _b.instanceCount) !== null && _c !== void 0 ? _c : 0;
            return __assign(__assign({}, state), { loadingIdentifiers: __assign(__assign({}, loadingIdentifiers), (_a = {}, _a[identifier] = __assign(__assign({}, loadingIdentifiers[identifier]), { instanceCount: instanceCount + 1 }), _a)) });
        },
        removeInstance: function (state, action) {
            var _a;
            var _b, _c;
            var loadingIdentifiers = state.loadingIdentifiers;
            var identifier = action.payload.identifier;
            var instanceCount = (_c = (_b = loadingIdentifiers[identifier]) === null || _b === void 0 ? void 0 : _b.instanceCount) !== null && _c !== void 0 ? _c : 0;
            return __assign(__assign({}, state), { loadingIdentifiers: __assign(__assign({}, loadingIdentifiers), (_a = {}, _a[identifier] = __assign(__assign({}, loadingIdentifiers[identifier]), { instanceCount: instanceCount - 1 }), _a)) });
        },
        updateLoadingState: function (state, action) {
            var _a;
            var loadingIdentifiers = state.loadingIdentifiers;
            var _b = action.payload, identifier = _b.identifier, isLoading = _b.isLoading;
            return __assign(__assign({}, state), { loadingIdentifiers: __assign(__assign({}, loadingIdentifiers), (_a = {}, _a[identifier] = __assign(__assign({}, loadingIdentifiers[identifier]), { isLoading: isLoading }), _a)) });
        },
        setLoader: function (state, action) {
            return __assign(__assign({}, state), { isLoaderEnabled: action.payload.isLoaderEnabled });
        },
    },
});
export var addInstance = (_a = loadingSlice.actions, _a.addInstance), removeInstance = _a.removeInstance, updateLoadingState = _a.updateLoadingState, setLoader = _a.setLoader;
export default loadingSlice.reducer;
